import type { AppData } from '../../../../types/app_data';

export enum StepNavType {
  None,
  Default,
  GarageOnly, // repairEstimate and carValue are using this nav, both are garage only
}

export interface StepNavProps {
  className?: string;
  goNext?: (appData?: AppData) => void;
  goBack?: () => void;
  stepIdx?: number;
  stepCnt?: number;
  categories?: string[];
  stepIndexInCategory?: number;
  stepCategoryCount?: number;
  stepCategoryName?: string;
  appData: AppData;
  categoryName?: string;
  stepNavType?: StepNavType;
}
